'use client'

import React from 'react'
import { Box, Flex, Text, Title } from '@mantine/core'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import { useUserContext } from '@/contexts/UserContext'
import { getDisplayableName } from '@/types/enums/StoreTypes'
import InsurancePill from '@/components/Refresh/InsuranceWidget/InsurancePill'
import type { RenderedService } from '@/types/interfaces/service-item'

type CategoryTextHeaderService = RenderedService & {
    mobileTitle?: string | null
}

export interface CategoryPageTextHeaderProps {
    categoryName: string
    service: CategoryTextHeaderService
}

/**
 * Centered title + subtitle for CMS `categoryTextHeader` sections.
 * Matches the legacy NavBarSubheader category chrome that SiteHeader omits.
 */
export default function CategoryPageTextHeader({ categoryName, service }: CategoryPageTextHeaderProps) {
    const { isSm } = useBreakpoint()
    const { user } = useUserContext()

    const title = service.title
    const mobileTitle = service.mobileTitle
    const subtitle = service.subtitle
    const fallbackTitle = getDisplayableName(categoryName)
    const displayTitle = title ? (isSm && mobileTitle ? mobileTitle : title) : fallbackTitle

    return (
        <Box w="100%" mx="auto">
            <Flex direction="column" align="center" gap={16} pt={50} pb={0}>
                <Title
                    ta="center"
                    order={1}
                    fz={54}
                    fw={'var(--weight-display-large, 400)'}
                    c={'rgb(31, 30, 29)'}
                    lts={'-0.96px'}
                    lh={'110%'}
                >
                    {displayTitle}
                </Title>
                {subtitle && (
                    <Text
                        ta="center"
                        fz={18}
                        fw={'var(--weight-text, 500)'}
                        lh={'130%'}
                        c={'rgb(31, 30, 29)'}
                        maw={isSm ? 345 : 600}
                    >
                        {subtitle}
                    </Text>
                )}
                {!user && <InsurancePill />}
            </Flex>
        </Box>
    )
}
